import { useCallback, useEffect } from "react"
import { useScrollLock as useTsScrollLock } from "usehooks-ts"

const useScrollLock: typeof useTsScrollLock = (...args) => {
  const { lock: tsLock, unlock: tsUnlock, isLocked } = useTsScrollLock(...args)
  const lock = useCallback(() => {
    if (isLocked) return
    tsLock()
    document.body.style.touchAction = 'none'
  }, [isLocked, tsLock])

  const unlock = useCallback(() => {
    if (!isLocked) return
    document.body.style.touchAction = ''
    tsUnlock()
  }, [isLocked, tsUnlock])

  useEffect(() => {
    return () => {
      document.body.style.touchAction = ''
    }
  }, [])

  return { lock, unlock, isLocked }
}

export default useScrollLock
